// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.capacity-table-container .capacity-parent-row {
  cursor: pointer;
  background-color: var(--m-table-bg, #ffffff);
  transition: background-color 0.2s ease;
}
.capacity-table-container .capacity-parent-row:hover {
  background-color: var(--m-table-hover-bg, #f8fafc);
}
.capacity-table-container .capacity-parent-row.expanded {
  background-color: #f0f9ff;
}
.capacity-table-container .capacity-parent-row.expanded td {
  border-bottom-color: transparent;
}
.capacity-table-container .capacity-parent-row .expand-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-right: 8px;
  color: #64748b;
  transition: transform 0.2s ease;
}
.capacity-table-container .capacity-parent-row .expand-icon.rotated {
  transform: rotate(90deg);
}
.capacity-table-container .capacity-parent-row .parent-title {
  font-weight: 600;
  color: #0f172a;
  display: inline-flex;
  align-items: center;
}
.capacity-table-container .capacity-parent-row .parent-title .badge {
  font-size: 0.75rem;
  color: #94a3b8;
  background-color: #f1f5f9;
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 8px;
  font-weight: normal;
}
.capacity-table-container .capacity-parent-row .parent-subtext {
  color: #64748b;
  font-size: 0.85rem;
}
.capacity-table-container .capacity-parent-row .parent-total {
  font-weight: 700;
  color: #0f172a;
}
.capacity-table-container .capacity-child-row {
  background-color: #ffffff;
}
.capacity-table-container .capacity-child-row td {
  padding-top: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f5f9;
}
.capacity-table-container .capacity-child-row td:first-child {
  position: relative;
  padding-left: 40px;
}
.capacity-table-container .capacity-child-row td:first-child::before {
  content: "";
  position: absolute;
  left: 20px;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: #cbd5e1;
}
.capacity-table-container .capacity-child-row .child-title {
  font-size: 0.9rem;
  color: #334155;
}
.capacity-table-container .capacity-child-row .child-machine {
  font-size: 0.9rem;
  font-weight: 500;
  color: #334155;
}
.capacity-table-container .capacity-child-row .child-machine .machine-badge {
  font-size: 0.75rem;
  color: #94a3b8;
  font-weight: normal;
  margin-left: 6px;
}
.capacity-table-container .capacity-child-row .child-capacity {
  color: #334155;
  font-weight: 500;
}
.capacity-table-container .capacity-total-row {
  background-color: #f0f9ff;
}
.capacity-table-container .capacity-total-row td {
  border-top: 2px solid #3b82f6;
  border-bottom: none;
  padding-top: 16px;
  padding-bottom: 16px;
}
.capacity-table-container .capacity-total-row .total-label {
  font-weight: 700;
  color: #1d4ed8;
  font-size: 0.95rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.capacity-table-container .capacity-total-row .total-value {
  font-weight: 700;
  color: #0f172a;
  font-size: 1.05rem;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/ProductionCapacity/ProductionCapacity.scss"],"names":[],"mappings":"AACE;EACE,eAAA;EACA,4CAAA;EACA,sCAAA;AAAJ;AAEI;EACE,kDAAA;AAAN;AAGI;EACE,yBAAA;AADN;AAGM;EACE,gCAAA;AADR;AAKI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,+BAAA;AAHN;AAKM;EACE,wBAAA;AAHR;AAOI;EACE,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;AALN;AAOM;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AALR;AASI;EACE,cAAA;EACA,kBAAA;AAPN;AAUI;EACE,gBAAA;EACA,cAAA;AARN;AAYE;EACE,yBAAA;AAVJ;AAYI;EACE,iBAAA;EACA,oBAAA;EACA,gCAAA;AAVN;AAcI;EACE,kBAAA;EACA,kBAAA;AAZN;AAcM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;AAZR;AAgBI;EACE,iBAAA;EACA,cAAA;AAdN;AAiBI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AAfN;AAiBM;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAfR;AAmBI;EACE,cAAA;EACA,gBAAA;AAjBN;AAqBE;EACE,yBAAA;AAnBJ;AAqBI;EACE,6BAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAnBN;AAsBI;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;AApBN;AAuBI;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;AArBN","sourcesContent":[".capacity-table-container {\n  .capacity-parent-row {\n    cursor: pointer;\n    background-color: var(--m-table-bg, #ffffff);\n    transition: background-color 0.2s ease;\n    \n    &:hover {\n      background-color: var(--m-table-hover-bg, #f8fafc);\n    }\n    \n    &.expanded {\n      background-color: #f0f9ff; // Very light blue to indicate expanded state\n      \n      td {\n        border-bottom-color: transparent; // Smooth transition to children\n      }\n    }\n\n    .expand-icon {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: 24px;\n      height: 24px;\n      margin-right: 8px;\n      color: #64748b;\n      transition: transform 0.2s ease;\n      \n      &.rotated {\n        transform: rotate(90deg);\n      }\n    }\n    \n    .parent-title {\n      font-weight: 600;\n      color: #0f172a;\n      display: inline-flex;\n      align-items: center;\n      \n      .badge {\n        font-size: 0.75rem;\n        color: #94a3b8;\n        background-color: #f1f5f9;\n        padding: 2px 6px;\n        border-radius: 4px;\n        margin-left: 8px;\n        font-weight: normal;\n      }\n    }\n    \n    .parent-subtext {\n      color: #64748b;\n      font-size: 0.85rem;\n    }\n    \n    .parent-total {\n      font-weight: 700;\n      color: #0f172a;\n    }\n  }\n\n  .capacity-child-row {\n    background-color: #ffffff;\n    \n    td {\n      padding-top: 12px;\n      padding-bottom: 12px;\n      border-bottom: 1px solid #f1f5f9;\n    }\n    \n    // Add vertical line effect for tree visual\n    td:first-child {\n      position: relative;\n      padding-left: 40px; // Indent child row\n      \n      &::before {\n        content: '';\n        position: absolute;\n        left: 20px; // Aligned with the middle of the parent chevron\n        top: 0;\n        bottom: 0;\n        width: 1px;\n        background-color: #cbd5e1;\n      }\n    }\n    \n    .child-title {\n      font-size: 0.9rem;\n      color: #334155;\n    }\n    \n    .child-machine {\n      font-size: 0.9rem;\n      font-weight: 500;\n      color: #334155;\n      \n      .machine-badge {\n        font-size: 0.75rem;\n        color: #94a3b8;\n        font-weight: normal;\n        margin-left: 6px;\n      }\n    }\n    \n    .child-capacity {\n      color: #334155;\n      font-weight: 500;\n    }\n  }\n  \n  .capacity-total-row {\n    background-color: #f0f9ff;\n    \n    td {\n      border-top: 2px solid #3b82f6; // Blue top border to highlight total\n      border-bottom: none;\n      padding-top: 16px;\n      padding-bottom: 16px;\n    }\n    \n    .total-label {\n      font-weight: 700;\n      color: #1d4ed8; // Dark blue\n      font-size: 0.95rem;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n    }\n    \n    .total-value {\n      font-weight: 700;\n      color: #0f172a;\n      font-size: 1.05rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
